import { ALERT_CONSTANTS, CONFIG_CONSTANTS } from '../../store/actionTypes'
import { CONSTANTS } from '../../utils'

const clearAppAlerts = {
	android: 'clear',
	ios: 'clear',
}
const showAppAlerts = {
	android: 'default',
	ios: 'alert',
}

const mobileInitState = {
	alertType: clearAppAlerts,
	background: '',
	color: '',
	autoDismiss: false,
}

const initState = {
	mobile: mobileInitState,
	type: null,
	message: null,
	group: CONSTANTS.ERROR_TYPE.TOAST,
	autoDismiss: false,
	clearAll: false,
	networkAvailable: true,
}

const alertReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case ALERT_CONSTANTS.NO_INTERNET_CONNECTION:
			return {
				...state,
				networkAvailable: action.state,
			}
		case ALERT_CONSTANTS.SUCCESS:
			return {
				...state,
				type: 'success',
				message: action.message,
				group: action.group,
				autoDismiss: action.autoDismiss,
				clearAll: false,
				mobile: {
					...initState.mobile,
					alertType: showAppAlerts,
					background: '#316100',
					color: '#FFFFFF',
				},
			}
		case ALERT_CONSTANTS.ERROR:
			return {
				...state,
				type: 'error',
				message: action.message,
				group: action.group,
				autoDismiss: action.autoDismiss,
				clearAll: false,
				mobile: {
					...initState.mobile,
					alertType: showAppAlerts,
					background: '#BF2600',
					color: '#FFFFFF',
				},
			}
		case ALERT_CONSTANTS.WARNING:
			return {
				...state,
				type: 'warning',
				message: action.message,
				group: action.group,
				autoDismiss: action.autoDismiss,
				clearAll: false,
				mobile: {
					...initState.mobile,
					alertType: showAppAlerts,
					background: '#f2994a',
					color: '#FFFFFF',
				},
			}
		case ALERT_CONSTANTS.CLEAR:
			return {
				...initState,
				clearAll: true,
				mobile: {
					...initState.mobile,
					type: 'clear',
				},
			}
		default:
			return state
	}
}

export default alertReducer
